import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export default function ReportVideoSummaryModal({ close, data: { videoUrl } }) {
    const md = useMediaQuery((theme) => theme.breakpoints.down('md'));
    return (
        <Box 
            sx={{
                maxWidth: '1008px',
                width: '100%',
                borderRadius: '8px',
                boxShadow: '0px 2px 10px 0px #5B87EF33',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                background: 'white',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            <Box 
                bgcolor='background.default'
                sx={{
                    display: 'flex',
                    padding: '20px',
                    justifyContent: 'space-between',
                    gap: '10px',
                    alignItems: 'center'
                }}
            >
                <Typography variant="h2">What we test and how it works</Typography>
                <CloseIcon 
                    sx={{
                        position: 'relative',
                        color: 'primary.black',
                        fontSize: '32px',
                        cursor: 'pointer'
                    }}
                    onClick={close}
                />
            </Box>
        <Stack
            direction={'column'}
            spacing={'32px'}
            sx={{
                px: md ? '20px' : '36px',
                pb: '40px',
                mt: '16px'
            }}
        >
            <Typography variant="body">
            Each report tests many genes for both known and even never before seen variants in your genome. Below is a video explaining what we test for this report and how it works.
            </Typography>
            <Box sx={{
                    maxWidth: '100%', 
                    mt: md ? '16px !important' : '32px !important', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    overflow: 'hidden',
                    height: 'fit-content',
                    position: 'relative'
                }}
                className="report-iframe-wrapper"
            >
            <iframe style={{
                position: 'absolute',
                maxWidth: '735px',
                width: '100%',
                height: '100%',
                left: '50%',
                top: 0,
                transform: 'translateX(-50%)',
                borderRadius: '4px'
            }} src={videoUrl} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen=""></iframe>
            </Box>
        </Stack>
        </Box>
    )
}